import { HTTP_STATUS_CODE, TWO_HUNDRED } from 'common/constants';
import { ErrorResponse } from 'pages/AuthorizePaymentPage/interCompany/types';

export const getResponseErrorMessage = (data: ErrorResponse | null): string =>
  data && HTTP_STATUS_CODE in data && data.httpStatusCode !== TWO_HUNDRED
    ? data.issues[0].issue
    : '';
